import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrokerInvitationService } from 'src/app/services/brokers/broker-invitation.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-broker-confirmation',
  standalone: false,
  templateUrl: './broker-confirmation.component.html',
  styleUrl: './broker-confirmation.component.scss',
})
export class BrokerConfirmationComponent implements OnInit {
  success = false;
  error = false;

  token: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loadingService: LoadingService,
    private brokerInvitationService: BrokerInvitationService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if (!this.token) {
      this.error = true;
      return;
    }

    this.confirmAccount();
  }

  private confirmAccount(): void {
    if(!this.token) return;

    this.loadingService.load(
      this.brokerInvitationService.confirmInvitation(this.token)
    ).subscribe({
      next: () => {
        this.success = true;
      },
      error: () => {
        this.error = true;
      }
    });
  }

  onLoginClick(): void {
    this.router.navigate(['dashboard']);
  }
}
